module.exports = __webpack_public_path__ + "img/dialog_bg.e221b8d4.png";